import Modal from '@components/v2/ui/Modal/Modal';
import LangEnum from '../../../../lang/LangEnum';
import { useTranslation } from '../../../translation/TranslationContext';
import ActivationLoginForm from './components/ActivationLoginForm';

interface ActivationLoginModalProps {
  isOpen: boolean;
  onClose: () => void;
  afterSubmit: () => void;
}

const ActivationLoginModal = ({ isOpen, onClose, afterSubmit }: ActivationLoginModalProps) => {
  const { translate } = useTranslation();

  return (
    <Modal
      isOpen={isOpen}
      size="standard"
      header={{ title: translate(LangEnum.REVIEW_PERSONAL_DATA) }}
      onClose={onClose}
    >
      <ActivationLoginForm afterSubmit={afterSubmit} />
    </Modal>
  );
};

export default ActivationLoginModal;
